import { onAuthStateChanged } from "firebase/auth";
import { doc, getDoc, updateDoc } from "firebase/firestore";
import { auth, db } from "./firebase-config";

const THEME_EVENT = "valovate-theme-change";

export const initializeAuthListener = () => {
  const defaultTheme = "dark";

  const applyTheme = (theme) => {
    console.log("Applying Theme:", theme); // Log the theme being applied
    document.documentElement.classList.remove("dark", "light");
    document.body.classList.remove("dark", "light"); // Also update the body class
    document.documentElement.classList.add(theme);
    document.body.classList.add(theme); // Add the theme to the body as well
    document.querySelectorAll(".toggle-checkbox").forEach((themeSwitcher) => {
      themeSwitcher.checked = theme === "light";
    });
    window.dispatchEvent(new CustomEvent(THEME_EVENT, { detail: { theme } }));
  };

  // Listen for authentication state changes
  onAuthStateChanged(auth, async (user) => {
    const loginButton = document.querySelector(".Login__button");

    if (user) {
      console.log("User is logged in:", user.email);

      // Fetch user's theme preference from Firestore
      const userRef = doc(db, "users", user.uid);
      try {
        const userDoc = await getDoc(userRef);
        const savedTheme = userDoc.exists() ? userDoc.data().theme || defaultTheme : defaultTheme;

        console.log("Fetched Theme from Firestore:", savedTheme); // Log the fetched theme

        localStorage.setItem("theme", savedTheme); // Save theme locally for fallback
        applyTheme(savedTheme); // Apply theme

        // If user doc doesn't exist, add theme without blowing away the rest
        // if (!userDoc.exists()) {
        //   await setDoc(userRef, { theme: defaultTheme }, { merge: true });
        // }        
  
      } catch (error) {
        console.error("Error fetching/updating user theme:", error);
      }

      // Update login button for logged-in user
      if (loginButton) {
        loginButton.textContent = "Account";
        loginButton.href = "/account";
        loginButton.classList.replace("Login__button", "Account__button");
      }
    } else {
      console.info("No user is logged in.");

      // Use theme from localStorage for logged-out users
      const savedTheme = localStorage.getItem("theme") || defaultTheme;
      console.log("Fetched Theme from Local Storage:", savedTheme); // Log the fetched theme
      applyTheme(savedTheme);

      if (loginButton) {
        loginButton.textContent = "Login";
        loginButton.href = "/login";
        loginButton.classList.replace("Account__button", "Login__button");
      }
    }

    // Add theme toggle functionality
    document.querySelectorAll(".toggle-checkbox").forEach((themeSwitcher) => {
      if (themeSwitcher.dataset.themeListenerBound === "1") return;
      themeSwitcher.dataset.themeListenerBound = "1";

      themeSwitcher.addEventListener("change", async (event) => {
        const selectedTheme = event.currentTarget.checked ? "light" : "dark";
        console.log("User Selected Theme:", selectedTheme); // Log the selected theme
        localStorage.setItem("theme", selectedTheme);
        applyTheme(selectedTheme);

        if (user) {
          try {
            const userRef = doc(db, "users", user.uid);
            await updateDoc(userRef, { theme: selectedTheme });
            console.log("Theme updated in Firestore:", selectedTheme);
          } catch (error) {
            console.error("Error updating theme in Firestore:", error);
          }
        }
      });
    });
  });
};

// Apply theme from localStorage immediately
export const applyInitialTheme = () => {
  const defaultTheme = "dark";
  const savedTheme = localStorage.getItem("theme") || defaultTheme;
  console.log("Initial Theme to Apply:", savedTheme); // Log the initial theme
  document.documentElement.classList.remove("dark", "light");
  document.body.classList.remove("dark", "light"); // Remove classes from body
  document.documentElement.classList.add(savedTheme);
  document.body.classList.add(savedTheme); // Add the saved theme class to body
};
